"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = require("./cache");
function setBasename(base) {
    return cache_1.setCache('basename', base);
}
exports.default = setBasename;
